module.exports = __webpack_public_path__ + "img/Chevron-left-filled.d6b256c9.svg";